module.exports = __webpack_public_path__ + "img/swhz.cc990e91.png";